import React from "react";

const skeletonItems = (count) => Array.from({ length: count }, (_, index) => index);

export const NotificationListSkeleton = ({ count = 4, withClose = false }) => (
  <div className="nlist aw-notification-skeleton-list" aria-hidden="true">
    {skeletonItems(count).map((item) => (
      <div
        className={`row aw-notification-skeleton-item ${
          withClose ? "box-shadow notification-item" : ""
        }`}
        key={`notification-skeleton-${item}`}
      >
        <div className="col-auto px-0">
          <span className="aw-page-skeleton-shape aw-notification-skeleton-avatar" />
        </div>
        <div className="col minfo aw-notification-skeleton-copy">
          <span className="aw-page-skeleton-shape aw-notification-skeleton-name" />
          <span className="aw-page-skeleton-shape aw-notification-skeleton-message" />
          <span className="aw-page-skeleton-shape aw-notification-skeleton-message short" />
        </div>
        {withClose && (
          <div className="col-auto aw-notification-skeleton-close-col">
            <span className="aw-page-skeleton-shape aw-notification-skeleton-close" />
          </div>
        )}
        <div className="time aw-notification-skeleton-time">
          <span className="aw-page-skeleton-shape" />
        </div>
      </div>
    ))}
  </div>
);
